export const formatPercentage = (number) =>
  `${Math.round(number * 10000) / 100}%`

export const onlyNums = (value) => value.replace(/[^\d]/g, '')

export const formatNumber = (value) =>
  String(value).replace(/(.)(?=(\d{3})+$)/g, '$1,')

export default formatPercentage
